import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49cb233e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pricing-list" }
const _hoisted_2 = { class: "pricing-card" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = ["innerHTML"]

import CSectionTwoColumn from "@/components/section/CSectionTwoColumn.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";
import {ref} from "vue";
import Service from "@/models/Service";
import RepositoryFactory from "@/factories/RepositoryFactory";


export default /*#__PURE__*/_defineComponent({
  __name: 'CServices',
  setup(__props) {

const services = ref<Array<Service>>([])

RepositoryFactory
  .default()
  .getServices()
  .then(data => services.value = data)

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createBlock(CSectionTwoColumn, {
    class: "section-columns--reverse",
    id: "services"
  }, {
    left: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_icon, {
                name: service.icon,
                "aria-hidden": "true",
                role: "img",
                class: "md hydrated"
              }, null, 8, ["name"]),
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(service.name_alias)), 1),
              _createElementVNode("data", {
                class: "card-price",
                value: "500",
                innerHTML: _ctx.$t(service.price_alias)
              }, null, 8, _hoisted_4)
            ])
          ]))
        }), 128))
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(CSectionSubtitle, { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('services-title')), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionTitle, { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('services-quote')), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionText, {
        style: {"text-align":"left","margin-top":"20px"},
        innerHTML: _ctx.$t('services-description')
      }, null, 8, ["innerHTML"])
    ]),
    _: 1
  }))
}
}

})